import React, { useState } from "react";
import CloseIcon from "../../images/Close.png";
import CorrectIcon from "../../images/correct.svg";
import RetryIcon from "../../images/retry.svg";
import "./BottomButtons.css";
import Modal from "../Modal";
import Portal from "../../views/Portal";

const BottomButtons = ({
  handleFullScreenCapture,
  type,
  setType,
  setCanvaOpenModal,
  openSSModal,
  setSSOpenModal,
  screenCapture,
  setShowFloat,
  parentStyle,
  isRecording 
}) => {
  const [captureTimer, setCaptureTimer] = useState(null);

  const handleClose = () => {
    setShowFloat(false);
    setType("none");
    clearTimeout(captureTimer);
  };

  const handleSave = () => {
    setShowFloat(true);
    setType("none");
    setCanvaOpenModal(true);
  };

  const handleRetry = () => {
    setType("shotType");
  };

  const handleClick = () => {
    setShowFloat(false);
    setType("none");
    const timer = setTimeout(() => {
      handleFullScreenCapture();
    }, 1000); 
    setCaptureTimer(timer);
  };

  return (
    <Portal parentStyle={parentStyle} portalId="bottom-buttons-portal">
    <div className='BottomBtnContainer' style={{...parentStyle.customIndex}} >
      {type === "shotType" && !isRecording && ( 
        <div className='BottomButtons'>
          <div
            onClick={handleClick}
            className='btn-texts btn-custom-hover'
          >
            Full Screen
          </div>
          <img
            className='btn-red'
            src={CloseIcon}
            onClick={handleClose}
            alt=''
          />
        </div>
      )}
      {type === "shotTaken" && !isRecording && ( 
        <Modal
          openModal={openSSModal}
          setOpenModal={setSSOpenModal}
          showCloseIcon={false}
          customClass='SSModal'
          parentStyle={parentStyle}
        >
          <img
            src={screenCapture}
            alt=''
            style={{ width: "750px", height: "450px", marginBottom: "25px", boxShadow: "0 0 12px 0 rgba(0, 0, 0, 0.12)" }}
          />
          <div className='BottomButtons' id='bg2'>
            <div className='btn-green' onClick={handleSave}>
              <img src={CorrectIcon} width='20px' height='20px' alt='Save' />
              <div>Save</div>
            </div>
            <div onClick={handleRetry} className='btn-texts btn-custom-hover'>
              <img src={RetryIcon} width='20px' height='20px' alt='Retry' />
            </div>
            <img
              className='btn-red'
              src={CloseIcon}
              onClick={handleClose}
              alt=''
            />
          </div>
        </Modal>
      )}
    </div>
    </Portal>
  );
};

export default BottomButtons;
